var React = require('react');

function ShoppingBag (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.5 0.5)"},[React.createElement("path",{"d":"M324.557,448.766V443.2a.206.206,0,0,0-.206-.206h-8.872a.206.206,0,0,0-.206.206v5.566a.206.206,0,0,1-.206.206h-3.555a.206.206,0,0,0-.206.206v14.165a.206.206,0,0,0,.206.206h16.535a.206.206,0,0,0,.206-.206V449.179a.206.206,0,0,0-.206-.206h-3.284A.206.206,0,0,1,324.557,448.766Z","transform":"translate(-311.306 -442.994)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"1","key":0}),React.createElement("rect",{"width":"3.647","height":"3.257","rx":"0.467","transform":"translate(6.822 2.738)","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"1","key":1})]));
}

ShoppingBag.defaultProps = {"width":"17.947","height":"21.555","viewBox":"0 0 17.947 21.555"};

module.exports = ShoppingBag;

ShoppingBag.default = ShoppingBag;
